import { Button } from '@material-ui/core'
import { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { sendPasswordEmail } from '../../../actions/emailActions'
import { EMAIL_PASSWORD_RESET } from '../../../constants/emailConstants'
import { useInput } from '../../../hooks/useInput'
import { Context } from '../../../providers/ProjectContextProvider'
import FormContainer from '../../Form/FormContainer'
import TextInput from '../../Form/TextInput'

const ForgotPassword = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { setShowContactSupport } = useContext(Context)

  const { value: email, bind: bindEmail } = useInput('')
  const emailPassword = useSelector((state) => state.emailPassword)
  const { loading, error, success } = emailPassword

  const submitHandler = (e) => {
    e.preventDefault()

    dispatch(sendPasswordEmail(email))
  }

  useEffect(() => {
    if (success) {
      dispatch({ type: EMAIL_PASSWORD_RESET })
      history.push('/password-recovery-sent')
    }
  }, [dispatch, success, history])

  return (
    <div className="login flex">
      <div
        className="bg-image"
        style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
      ></div>
      <FormContainer>
        <h2>Password reset</h2>
        <p className="fs14 m-b-25">
          Enter your work email and we’ll send you a link to reset your
          password. Having trouble?{' '}
          <span className="link" onClick={() => setShowContactSupport(true)}>
            Contact support here.
          </span>
        </p>
        <form onSubmit={submitHandler}>
          <TextInput
            name="email"
            type="email"
            label="Email"
            bindValue={bindEmail}
            error={error}
          />

          <div className="flex flex-end m-t-40">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => history.push('/login')}
              className="m-r-25"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={email === '' || loading}
            >
              Send reset link
            </Button>
          </div>
        </form>
      </FormContainer>
    </div>
  )
}

export default ForgotPassword
